import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    addWebReview: string;
    newFolder: string;
    newRestrictedFolder: string;
    uploadFile: string;
    uploadFolder: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            addWebReview: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateAssetMenu.addWebReview?c=10a56r6e9rm2k", defaultMessage: "Add Web Review" }));
                },
                enumerable: true,
                configurable: true
            },
            newFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateAssetMenu.newFolder?c=hz1l49khdeht", defaultMessage: "New Folder" }));
                },
                enumerable: true,
                configurable: true
            },
            newRestrictedFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateAssetMenu.newRestrictedFolder?c=3bkxqej52favx", defaultMessage: "New Restricted Folder" }));
                },
                enumerable: true,
                configurable: true
            },
            uploadFile: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateAssetMenu.uploadFile?c=2r2ily5gfaabg", defaultMessage: "Upload Asset" }));
                },
                enumerable: true,
                configurable: true
            },
            uploadFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateAssetMenu.uploadFolder?c=31z0qfh0ynkyo", defaultMessage: "Upload Folder" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
